import { Reveal, Eyebrow } from "../components/Reveal";
import { CONTACT } from "../data/experiences";

const SECTIONS = [
  {
    title: "Bookings and confirmations",
    body: "Every journey is confirmed in writing with a detailed itinerary and inclusion list. A booking is confirmed only when the deposit is received. The balance is due before the travel start date, on the schedule stated in your confirmation.",
  },
  {
    title: "Traveller responsibilities",
    body: "Travellers are responsible for valid passports, visas, vaccinations and comprehensive travel insurance. School and university groups must travel with the faculty ratios agreed in writing. We can arrange visa support letters and insurance referrals on request.",
  },
  {
    title: "Suppliers",
    body: "We act as a tour operator and engage licensed third-party guides, hotels and transport partners to deliver services. Partners are vetted for licensing, insurance and conduct, and remain bound by their own terms as well as ours.",
  },
  {
    title: "Changes and liability",
    body: "If weather, closures or safety concerns require itinerary changes, we will provide alternatives of equal standard. Our liability is limited to the value of the services booked through us. Nothing in these terms limits your statutory rights.",
  },
  {
    title: "Governing law",
    body: "These terms are governed by the laws of India, with courts at New Delhi holding jurisdiction.",
  },
];

export default function Terms() {
  return (
    <main data-testid="terms-page" className="bg-ivory">
      <section className="pt-40 pb-16 bg-obsidian text-ivory">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-accent text-xs tracking-[0.4em] text-gold mb-6">LEGAL</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl" data-testid="terms-headline">Terms & Conditions.</h1>
        </div>
      </section>
      <section className="py-20 sm:py-28">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 space-y-14">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title}>
              <section data-testid={`terms-section-${i}`}>
                <Eyebrow>{String(i + 1).padStart(2, "0")}</Eyebrow>
                <h2 className="mt-3 font-serif text-3xl text-maroon mb-4">{s.title}</h2>
                <p className="text-[#5C4F52] text-base leading-relaxed">{s.body}</p>
              </section>
            </Reveal>
          ))}
          <Reveal>
            <p className="text-sm text-[#5C4F52]/70 border-t border-gold/25 pt-8">
              Questions about these terms? Write to {CONTACT.email}. {CONTACT.company}, New Delhi, India.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
